import LoadingMessageComponent from './LoadingMessageComponent';
export default LoadingMessageComponent;
